import { lazyLoadWithFallback } from "./lazy-load-with-fallback.js";
const iconMap = {
  // GENERIC
  star: lazyLoadWithFallback(() => import("./static/generic/static/generic/star.svg.js")),
  qrScan: lazyLoadWithFallback(() => import("./static/generic/static/generic/qr-code-scan.svg.js")),
  // COMMERCE
  "address-book": lazyLoadWithFallback(() => import("./static/contact/static/contact/address-book.svg.js")),
  "add-to-cart": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/add-to-cart.svg.js")),
  astigmatism: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/astigmatism.svg.js")),
  business: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/business.svg.js")),
  "calendar-monthly": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/calendar-monthly.svg.js")),
  "calendar-quarterly": lazyLoadWithFallback(
    () => import("./static/commerce/static/commerce/calendar-quarterly.svg.js")
  ),
  "card-payment": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/card-payment.svg.js")),
  "cash-payment": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/cash-payment.svg.js")),
  "credit-card": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/credit-card.svg.js")),
  delivery: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/delivery.svg.js")),
  "discount-bubble": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/discount-bubble.svg.js")),
  discount: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/discount.svg.js")),
  "eye-test": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/eye-test.svg.js")),
  "eye-test-alt": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/eye-test-alt.svg.js")),
  "favourite-empty": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/favourite-empty.svg.js")),
  "favourite-filled": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/favourite-filled.svg.js")),
  "for-baby": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/for-baby.svg.js")),
  "for-dry-eyes": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/for-dry-eyes.svg.js")),
  "for-kids": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/for-kids.svg.js")),
  franchise: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/franchise.svg.js")),
  "last-chance": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/last-chance.svg.js")),
  parcel: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/parcel.svg.js")),
  "seen-on-tv": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/seen-on-tv.svg.js")),
  "three-d-printed": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/three-d-printed.svg.js")),
  trendy: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/trendy.svg.js")),
  "happy-computer": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/happy-computer.svg.js")),
  "iris-scan": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/iris-scan.svg.js")),
  return: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/returns.svg.js")),
  // Backwards compatibility with cms
  returns: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/returns.svg.js")),
  // Backwards compatibility with cms
  "returns-alt": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/returns-alt.svg.js")),
  "shopping-bag": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/shopping-bag.svg.js")),
  "shopping-bag-alt": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/shopping-bag-alt.svg.js")),
  "shop-assistant": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/shop-assistant.svg.js")),
  store: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/store.svg.js")),
  truck: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/truck.svg.js")),
  "left-eye": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/left-eye.svg.js")),
  "payback-card": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/payback-card.svg.js")),
  "right-eye": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/right-eye.svg.js")),
  printer: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/printer.svg.js")),
  "new-collection": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/new-collection.svg.js")),
  "blue-light-filter": lazyLoadWithFallback(
    () => import("./static/commerce/static/commerce/blue-light-filter.svg.js")
  ),
  sustainable: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/sustainable.svg.js")),
  "polarised-glasses": lazyLoadWithFallback(
    () => import("./static/commerce/static/commerce/polarised-glasses.svg.js")
  ),
  "shopping-basket-star": lazyLoadWithFallback(
    () => import("./static/commerce/static/commerce/shopping-basket-star.svg.js")
  ),
  billing: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/billing.svg.js")),
  company: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/company.svg.js")),
  newsletter: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/newsletter.svg.js")),
  "smart-glasses": lazyLoadWithFallback(() => import("./static/commerce/static/commerce/smart-glasses.svg.js")),
  // CONTACT
  calendar: lazyLoadWithFallback(() => import("./static/contact/static/contact/calendar.svg.js")),
  location: lazyLoadWithFallback(() => import("./static/contact/static/contact/location.svg.js")),
  mail: lazyLoadWithFallback(() => import("./static/contact/static/contact/mail.svg.js")),
  "mail-with-circle": lazyLoadWithFallback(() => import("./static/contact/static/contact/mail-with-circle.svg.js")),
  phone: lazyLoadWithFallback(() => import("./static/contact/static/contact/phone.svg.js")),
  "phone-with-cord": lazyLoadWithFallback(() => import("./static/contact/static/contact/phone-with-cord.svg.js")),
  warranty: lazyLoadWithFallback(() => import("./static/commerce/static/commerce/warranty.svg.js")),
  // FACE SHAPES
  "face-shape-diamond": lazyLoadWithFallback(() => import("./static/face-shapes/static/face-shapes/diamond.svg.js")),
  "face-shape-heart": lazyLoadWithFallback(() => import("./static/face-shapes/static/face-shapes/heart.svg.js")),
  "face-shape-oval": lazyLoadWithFallback(() => import("./static/face-shapes/static/face-shapes/oval.svg.js")),
  "face-shape-rectangular": lazyLoadWithFallback(
    () => import("./static/face-shapes/static/face-shapes/rectangular.svg.js")
  ),
  "face-shape-round": lazyLoadWithFallback(() => import("./static/face-shapes/static/face-shapes/round.svg.js")),
  "face-shape-square": lazyLoadWithFallback(() => import("./static/face-shapes/static/face-shapes/square.svg.js")),
  // FRAME SHAPES
  "frame-shape-almond": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/almond.svg.js")),
  "frame-shape-aviator": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/aviator.svg.js")),
  "frame-shape-pilot": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/pilot.svg.js")),
  "frame-shape-butterfly": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/butterfly.svg.js")
  ),
  "frame-shape-cat-eye": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/cat-eye.svg.js")),
  "frame-shape-hexagon": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/hexagon.svg.js")),
  "frame-shape-hexagonal": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/hexagonal.svg.js")
  ),
  "frame-shape-irregular": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/irregular.svg.js")
  ),
  "frame-shape-mask": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/mask.svg.js")),
  "frame-shape-oval": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/oval.svg.js")),
  "frame-shape-pillow": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/pillow.svg.js")),
  "frame-shape-rectangle": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/rectangle.svg.js")
  ),
  "frame-shape-rectangle-square": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/rectangle-square.svg.js")
  ),
  "frame-shape-round": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/round.svg.js")),
  "frame-shape-shield": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/shield.svg.js")),
  "frame-shape-sporty": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/sporty.svg.js")),
  "frame-shape-square": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/square.svg.js")),
  "frame-shape-round-oval": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/round-oval.svg.js")
  ),
  "frame-shape-panto": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/panto.svg.js")),
  "frame-shape-panthos": lazyLoadWithFallback(() => import("./static/frame-shapes/static/frame-shapes/panthos.svg.js")),
  "frame-shape-undefined": lazyLoadWithFallback(
    () => import("./static/frame-shapes/static/frame-shapes/undefined.svg.js")
  ),
  // GLASSES
  "glasses-broken": lazyLoadWithFallback(() => import("./static/glasses/static/glasses/glasses-broken.svg.js")),
  glasses: lazyLoadWithFallback(() => import("./static/glasses/static/glasses/glasses.svg.js")),
  "glasses-retro": lazyLoadWithFallback(() => import("./static/glasses/static/glasses/glasses-retro.svg.js")),
  "glasses-futuristic": lazyLoadWithFallback(
    () => import("./static/glasses/static/glasses/glasses-futuristic.svg.js")
  ),
  sunglasses: lazyLoadWithFallback(() => import("./static/glasses/static/glasses/sunglasses.svg.js")),
  // INTERFACE
  "alert-circle": lazyLoadWithFallback(() => import("./static/interface/static/interface/alert-circle.svg.js")),
  "chevron-down": lazyLoadWithFallback(() => import("./static/interface/chevron/static/interface/chevron/chevron-down.svg.js")),
  "chevron-left": lazyLoadWithFallback(() => import("./static/interface/chevron/static/interface/chevron/chevron-left.svg.js")),
  "chevron-right": lazyLoadWithFallback(
    () => import("./static/interface/chevron/static/interface/chevron/chevron-right.svg.js")
  ),
  "chevron-up": lazyLoadWithFallback(() => import("./static/interface/chevron/static/interface/chevron/chevron-up.svg.js")),
  checklist: lazyLoadWithFallback(() => import("./static/interface/static/interface/checklist.svg.js")),
  checkmark: lazyLoadWithFallback(() => import("./static/interface/static/interface/checkmark.svg.js")),
  "checkmark-circle": lazyLoadWithFallback(() => import("./static/interface/static/interface/checkmark-circle.svg.js")),
  clock: lazyLoadWithFallback(() => import("./static/interface/static/interface/clock.svg.js")),
  close: lazyLoadWithFallback(() => import("./static/interface/static/interface/close.svg.js")),
  content: lazyLoadWithFallback(() => import("./static/interface/static/interface/content.svg.js")),
  clear: lazyLoadWithFallback(() => import("./static/interface/static/interface/clear.svg.js")),
  "double-chevron-left": lazyLoadWithFallback(
    () => import("./static/interface/chevron/static/interface/chevron/double-chevron-left.svg.js")
  ),
  "double-chevron-right": lazyLoadWithFallback(
    () => import("./static/interface/chevron/static/interface/chevron/double-chevron-right.svg.js")
  ),
  dots: lazyLoadWithFallback(() => import("./static/interface/static/interface/dots.svg.js")),
  driving: lazyLoadWithFallback(() => import("./static/interface/static/interface/driving.svg.js")),
  eye: lazyLoadWithFallback(() => import("./static/interface/static/interface/eye.svg.js")),
  "eye-slash": lazyLoadWithFallback(() => import("./static/interface/static/interface/eye-slash.svg.js")),
  filter: lazyLoadWithFallback(() => import("./static/interface/static/interface/filter.svg.js")),
  gps: lazyLoadWithFallback(() => import("./static/interface/static/interface/gps.svg.js")),
  hamburger: lazyLoadWithFallback(() => import("./static/interface/static/interface/hamburger.svg.js")),
  info: lazyLoadWithFallback(() => import("./static/interface/static/interface/info.svg.js")),
  "info-filled": lazyLoadWithFallback(() => import("./static/interface/static/interface/info-filled.svg.js")),
  "information-circle": lazyLoadWithFallback(
    () => import("./static/interface/static/interface/information-circle.svg.js")
  ),
  "learn-more": lazyLoadWithFallback(() => import("./static/interface/static/interface/learn-more.svg.js")),
  "learn-more-filled": lazyLoadWithFallback(
    () => import("./static/interface/static/interface/learn-more-filled.svg.js")
  ),
  letter: lazyLoadWithFallback(() => import("./static/interface/static/interface/letter.svg.js")),
  list: lazyLoadWithFallback(() => import("./static/interface/static/interface/list.svg.js")),
  "location-current": lazyLoadWithFallback(() => import("./static/interface/static/interface/location-current.svg.js")),
  "location-pin": lazyLoadWithFallback(() => import("./static/interface/static/interface/location-pin.svg.js")),
  minus: lazyLoadWithFallback(() => import("./static/interface/static/interface/minus.svg.js")),
  pause: lazyLoadWithFallback(() => import("./static/interface/static/interface/pause.svg.js")),
  paperclip: lazyLoadWithFallback(() => import("./static/upload/static/upload/paperclip.svg.js")),
  pencil: lazyLoadWithFallback(() => import("./static/interface/static/interface/pencil.svg.js")),
  plus: lazyLoadWithFallback(() => import("./static/interface/static/interface/plus.svg.js")),
  play: lazyLoadWithFallback(() => import("./static/interface/static/interface/play.svg.js")),
  questionmark: lazyLoadWithFallback(() => import("./static/interface/static/interface/questionmark.svg.js")),
  "questionmark-filled": lazyLoadWithFallback(
    () => import("./static/interface/static/interface/questionmark-filled.svg.js")
  ),
  search: lazyLoadWithFallback(() => import("./static/interface/static/interface/search.svg.js")),
  share: lazyLoadWithFallback(() => import("./static/interface/static/interface/share.svg.js")),
  sheet: lazyLoadWithFallback(() => import("./static/interface/static/interface/sheet.svg.js")),
  tools: lazyLoadWithFallback(() => import("./static/interface/static/interface/tools.svg.js")),
  trash: lazyLoadWithFallback(() => import("./static/interface/static/interface/trash.svg.js")),
  user: lazyLoadWithFallback(() => import("./static/interface/static/interface/user.svg.js")),
  "user-search": lazyLoadWithFallback(() => import("./static/interface/static/interface/user-search.svg.js")),
  walking: lazyLoadWithFallback(() => import("./static/interface/static/interface/walking.svg.js")),
  warning: lazyLoadWithFallback(() => import("./static/interface/static/interface/warning.svg.js")),
  wheelchair: lazyLoadWithFallback(() => import("./static/interface/static/interface/wheelchair.svg.js")),
  // LENSES
  lens: lazyLoadWithFallback(() => import("./static/lenses/static/lenses/lens.svg.js")),
  solution: lazyLoadWithFallback(() => import("./static/lenses/static/lenses/solution.svg.js")),
  // MY ACCOUNT
  frame: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/frame.svg.js")),
  lock: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/lock.svg.js")),
  login: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/login.svg.js")),
  logout: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/logout.svg.js")),
  orders: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/orders.svg.js")),
  "folded-page-with-text": lazyLoadWithFallback(
    () => import("./static/my-account/static/my-account/folded-page-with-text.svg.js")
  ),
  reschedule: lazyLoadWithFallback(() => import("./static/my-account/static/my-account/reschedule.svg.js")),
  "shipment-next": lazyLoadWithFallback(() => import("./static/my-account/static/my-account/shipment-next.svg.js")),
  "user-checkmark": lazyLoadWithFallback(() => import("./static/my-account/static/my-account/user-checkmark.svg.js")),
  "social-apple": lazyLoadWithFallback(() => import("./static/my-account/static/my-account/social-apple.svg.js")),
  "social-google": lazyLoadWithFallback(() => import("./static/my-account/static/my-account/social-google.svg.js")),
  // PRESCRIPTION
  "store-eye-test": lazyLoadWithFallback(() => import("./static/prescription/static/prescription/store-eye-test.svg.js")),
  // PRODUCTS
  "360-deg": lazyLoadWithFallback(() => import("./static/products/static/products/360-deg.svg.js")),
  "try-on": lazyLoadWithFallback(() => import("./static/products/static/products/try-on.svg.js")),
  // UPLOAD
  "upload-prescription": lazyLoadWithFallback(
    () => import("./static/upload/static/upload/upload-prescription.svg.js")
  ),
  "upload-pd": lazyLoadWithFallback(() => import("./static/upload/static/upload/upload-pd.svg.js")),
  // APPOINTMENTS
  "calendar-time": lazyLoadWithFallback(() => import("./static/appointments/static/appointments/calendar-time.svg.js")),
  "chat-bubble": lazyLoadWithFallback(() => import("./static/appointments/static/appointments/chat-bubble.svg.js")),
  "child-appointment": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/child-appointment.svg.js")
  ),
  "hearing-test": lazyLoadWithFallback(() => import("./static/appointments/static/appointments/hearing-test.svg.js")),
  repairs: lazyLoadWithFallback(() => import("./static/appointments/static/appointments/repairs.svg.js")),
  "eye-test-contact-lens": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/eye-test-contact-lens.svg.js")
  ),
  "eye-test-drivers": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/eye-test-drivers.svg.js")
  ),
  "eye-test-glasses": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/eye-test-glasses.svg.js")
  ),
  "eye-test-medical-card": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/eye-test-medical-card.svg.js")
  ),
  megaphone: lazyLoadWithFallback(() => import("./static/appointments/static/appointments/megaphone.svg.js")),
  "nuance-audio": lazyLoadWithFallback(() => import("./static/appointments/static/appointments/nuance-audio.svg.js")),
  "sunglasses-retro": lazyLoadWithFallback(
    () => import("./static/appointments/static/appointments/sunglasses-retro.svg.js")
  ),
  "video-call": lazyLoadWithFallback(() => import("./static/appointments/static/appointments/video-call.svg.js")),
  // PAYMENT METHODS
  amex: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/amex.svg.js")),
  bancontact: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/bancontact.svg.js")),
  "cash-on-delivery": lazyLoadWithFallback(
    () => import("./static/payment-methods/static/payment-methods/cash-on-delivery.svg.js")
  ),
  dankort: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/dankort.svg.js")),
  ideal: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/ideal.svg.js")),
  klarna: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/klarna.svg.js")),
  maestro: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/maestro.svg.js")),
  mastercard: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/mastercard.svg.js")),
  mbway: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/mbway.svg.js")),
  mobilepay: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/mobilepay.svg.js")),
  multibanco: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/multibanco.svg.js")),
  oney: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/oney.svg.js")),
  paypal: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/paypal.svg.js")),
  sepa: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/sepa.svg.js")),
  swish: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/swish.svg.js")),
  twint: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/twint.svg.js")),
  visa: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/visa.svg.js")),
  bizum: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/bizum.svg.js")),
  "apple-checkout-button-icon": lazyLoadWithFallback(
    () => import("./static/payment-methods/static/payment-methods/apple-checkout-button-icon.svg.js")
  ),
  "paypal-checkout-button-icon": lazyLoadWithFallback(
    () => import("./static/payment-methods/static/payment-methods/paypal-checkout-button-icon.svg.js")
  ),
  apple: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/apple.svg.js")),
  googlepay: lazyLoadWithFallback(() => import("./static/payment-methods/static/payment-methods/googlepay.svg.js")),
  "google-checkout-button-icon": lazyLoadWithFallback(
    () => import("./static/payment-methods/static/payment-methods/google-checkout-button-icon.svg.js")
  ),
  //BANK ICONS
  asn: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/asn.svg.js")),
  bunq: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/bunq.svg.js")),
  knab: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/knab.svg.js")),
  rabo: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/rabo.svg.js")),
  regio: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/regio.svg.js")),
  revolut: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/revolut.svg.js")),
  triodos: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/triodos.svg.js")),
  vanLanschot: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/van-lanschot.svg.js")),
  abn: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/abn.svg.js")),
  ing: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/ing.svg.js")),
  sns: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/sns.svg.js")),
  abnAmro: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/abn-amro.svg.js")),
  yourSafe: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/your-safe.svg.js")),
  bank: lazyLoadWithFallback(() => import("./static/bank-icons/static/bank-icons/bank.svg.js")),
  // DONATIONS
  onesight: lazyLoadWithFallback(() => import("./static/donations/static/donations/onesight.svg.js")),
  // Feature icons
  reading: lazyLoadWithFallback(
    () => import("./static/feature-icons/static/feature-icons/is-offered-with-prescriptions.svg.js")
  ),
  polarized: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/polarized.svg.js")),
  uv: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/uv.svg.js")),
  hydration: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/hydration.svg.js")),
  softness: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/softness.svg.js")),
  breathability: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/breathability.svg.js")),
  fatigue: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/fatigue.svg.js")),
  basics: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/basics.svg.js")),
  disinfect: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/disinfect.svg.js")),
  comfort: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/comfort.svg.js")),
  cleaning: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/cleaning.svg.js")),
  sensitivity: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/sensitivity.svg.js")),
  rinsing: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/rinsing.svg.js")),
  blueFilter: lazyLoadWithFallback(() => import("./static/feature-icons/static/feature-icons/blue-filter.svg.js")),
  isOfferedWithPrescriptions: lazyLoadWithFallback(
    () => import("./static/feature-icons/static/feature-icons/is-offered-with-prescriptions.svg.js")
  )
};
const iconNames = Object.keys(iconMap);
const iconExists = (name) => iconNames.includes(name);
function getIconByName(name) {
  return iconMap[name];
}
export {
  getIconByName,
  iconExists,
  iconMap,
  iconNames
};
//# sourceMappingURL=get-icon-by-name.js.map
